<div class="datiq-cell-change" [ngStyle]="{ color: color }">
    <mat-icon
        [svgIcon]="icon"
        class="datiq-cell-change__icon"
        [ngClass]="{
            'datiq-cell-change__icon--positive': isPositive,
            'datiq-cell-change__icon--negative': isNegative
        }"
    >
    </mat-icon>
    <datiq-cell-label [settings]="settings?.cell"></datiq-cell-label>
</div>
